import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Wishlist from "./Wishlist";
import {
  Card,
  Typography,
  Button,
  CardBody,
  CardFooter,
} from "@material-tailwind/react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import { ProfileSideNav } from "../Account/ProfileSideNav";
import HeaderProf from "../../components/home/Header/HeaderProf";
import Footer from "../../components/home/Footer/Footer";
import FooterBottom from "../../components/home/Footer/FooterBottom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function WishlistItem() {
  const dispatch = useDispatch();
  const [wishlist, setWishlist] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    // Fetch the wishlist data for the current page
    fetchWishlistData(token, currentPage);
  }, [currentPage]);

  const fetchWishlistData = (token, page) => {
    axios
      .get(`https://erp.digitalindustryagency.com/api/wishlist?page=${page}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const wishlistData = response.data.data.resource.data;
        setWishlist(wishlistData);
        setCurrentPage(response.data.data.resource.current_page);
        setTotalPages(response.data.data.resource.last_page);
      })
      .catch((error) => {
        console.error("Error fetching wishlist data:", error);
      });
  };

  const handleDeleteItem = (productId) => {
    const token = localStorage.getItem("accessToken");
    axios
      .delete(
        `https://erp.digitalindustryagency.com/api/wishlist/${productId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        // Remove the deleted item from the local state
        const updatedWishlist = wishlist.filter(
          (item) => item.id !== productId
        );
        setSuccessMsg("Wishlist Berhasil Dihapus.");
        toast.success("Wishlist Berhasil Dihapus.");
        setWishlist(updatedWishlist);
        console.log("Berhasil hapus wishlist");
      })
      .catch((err) => {
        console.log("DELETE WISHLIST", err);
      });
  };

  const handlePageChange = (newPage) => {
    // Update the current page state to trigger a re-fetch
    setCurrentPage(newPage);
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen w-screen grid w-full">
      <div>
        <div className="max-w-container mx-auto px-4">
          {/* <Breadcrumbs title="Profile" /> */}
          {/* ================= Products Start here =================== */}
          <div className="w-full h-full flex pb-20 gap-10">
            <div className="lg:w-1/5 md:w-1/4 hidden md:inline-flex h-full">
              <div className="flex flex-col space-y-4">
                <Breadcrumbs title="Profile" />
                <ProfileSideNav />
              </div>
            </div>
            <div className="w-full lg:w-3/4 md:w-5/6 h-full flex flex-col md:gap-10">
              <HeaderProf />
              <h1 className="text-lg font-semibold">Wishlist</h1>
              <Card>
                <CardBody className="overflow-y-auto max-h-96 px-0">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {/* Gunakan grid untuk menampilkan produk */}
                    {wishlist.map((item) => (
                      <div key={item.id}>
                        <Wishlist
                          item={item}
                          onDelete={() => handleDeleteItem(item.id)}
                        />
                        <ToastContainer position="top-right" autoClose={3000} />
                      </div>
                    ))}
                  </div>
                </CardBody>
                <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal"
                  >
                    Page {currentPage} of {totalPages}
                  </Typography>
                  <div className="flex gap-2">
                    <Button
                      variant="outlined"
                      size="sm"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            </div>
          </div>
        </div>
        <Footer />
        <FooterBottom />
      </div>
    </div>
  );
}
